import { default as MuiSvgIcon } from '@mui/material/SvgIcon';

/**
 * SvgIcon is used to render SVG path elements, providing a wrapper with accessibility support.
 *
 * Demos:
 *
 * - [Unify Icons](https://unify.workiva.org/components/developer-utilities/unify-icons)
 */
export const SvgIcon = MuiSvgIcon;
export { type SvgIconProps, svgIconClasses } from '@mui/material/SvgIcon';
